import React from 'react';
import HistoryTableHeader from './historyTableHeader';
import { ClientTableColumnCaptions } from './tableColumnCaptions';

const ClientHistoryTableHeader = (props) => {
  const { editedFields, objectData } = props;

  const title = [{
    title: ClientTableColumnCaptions.fullName,
    value: objectData ? objectData.fullName : '',
  }];

  const extraProperties = ['legalForm', 'name', 'legalAddress'];

  return <HistoryTableHeader editedFields={editedFields} captions={ClientTableColumnCaptions} objectData={objectData} title={title} extraProperties={extraProperties}/>
};

export default ClientHistoryTableHeader;


// WEBPACK FOOTER //
// ./src/components/clientHistoryTableHeader.js